export enum RoleModule {
  Quotes = 2,
  Jobs = 3,
  Leads = 4,
  Reports = 8,
  Customers = 9,
  Type = 13,
  Pricing = 14

}
